module.exports = __webpack_public_path__ + "static/media/features_stories.84bb36d5.svg";